import { EntityRequiredSubmittal } from '@abb-procure/data';
import {
  Component,
  ViewEncapsulation,
  input,
  ChangeDetectionStrategy,
} from '@angular/core';
import { FormRowDirective } from '../../directives/form-row.directive';
import { Checkbox } from '../checkbox/checkbox.component';
import { ExpansionPanel } from '../expansion-panel/expansion-panel.component';
import { Hint } from '../hint/hint.component';
import { ShowField } from '../show-field/show-field.component';

@Component({
  selector: 'procure-show-submittals',
  templateUrl: './show-submittals.component.html',
  styleUrl: './show-submittals.component.scss',
  imports: [Checkbox, ExpansionPanel, Hint, FormRowDirective, ShowField],
  changeDetection: ChangeDetectionStrategy.Eager,
  encapsulation: ViewEncapsulation.None,
})
export class ShowSubmittals {
  readonly value = input<EntityRequiredSubmittal[] | null | undefined>();
  readonly label = input<string>();
  readonly hint = input<string>();
  readonly additionalLabel = input<string>('Comments');
}
